import { render } from "./forgot-password.vue?vue&type=template&id=4fcbd29d&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=4fcbd29d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcbd29d"]])

export default __exports__